<div
  *ngIf="rows.length > 0; else empty"
  class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4"
>
  <div
    *ngFor="let row of rows"
    class="bg-white rounded-xl shadow-md border border-gray-200 p-5 transition hover:shadow-lg"
    [class.cursor-pointer]="context !== 'users'"
    (click)="context !== 'users' ? onRowClick(row) : null"
  >
    <!-- Header -->
    <div class="flex justify-between items-center mb-2">
      <h2
        class="text-base font-semibold text-gray-800"
        [class]="
          context === 'routing-slips' || context === 'documents' || context === 'letters'
            ? 'text-blue-600 hover:text-blue-800 underline cursor-pointer'
            : 'text-gray-800'
        "
        (click)="(context === 'routing-slips' || context === 'documents' || context === 'letters') ? onDocumentNameClick(row) : null; $event.stopPropagation()"
      >
        {{ getDisplayName(row) }}
      </h2>

      <!-- Action Menu (only for non-user context and when actions are enabled) -->
      <app-action-menu
        *ngIf="context !== 'users' && showActions"
        [row]="row"
        [context]="context === 'routing-slips' ? 'routing-slip' : context"
        [getPermissionForRow]="getPermissionForRow"
        (viewClick)="onRowClick($event)"
        (auditLog)="onAuditLog($event)"
        (approve)="onApprove($event)"
        (reject)="onReject($event)"
        (comment)="onComment($event)"
        (edit)="onEdit($event)"
        (delete)="onDelete($event)"
        (click)="$event.stopPropagation()"
      >
      </app-action-menu>
    </div>

    <!-- Details -->
    <div class="text-sm text-gray-600 space-y-2">
      <!-- User context fields -->
      <div *ngIf="context === 'users'">
        <p>
          <span class="font-medium text-gray-700">Email:</span>
          {{ row.emailAddress || "Not Available" }}
        </p>
        <p>
          <span class="font-medium text-gray-700">Type:</span>
          <span
            class="px-2 py-0.5 rounded-full text-xs bg-blue-100 text-blue-700"
          >
            {{ row.userRole || "Not Available" }}
          </span>
        </p>
        <p>
          <span class="font-medium text-gray-700">Created Date:</span>

          {{ row.createdOn || "Not Available" }}
        </p>
        <p *ngIf="showActions" class="flex flex-wrap">
          <span
            class="text-xs rounded-full font-medium mb-2 px-2 py-0.5"
            [ngClass]="{
              'bg-green-100 text-green-700': row.status === 'Active',
              'bg-red-100 text-red-700': row.status === 'Inactive',
              'bg-gray-100 text-gray-700': row.status === 'Archived'
            }"
          >
            {{ row.status || "Not Available" }}
          </span>
        </p>
      </div>

      <!-- Routing Slips context fields -->
      <div *ngIf="context === 'routing-slips'">
        <p>
          <span class="font-medium text-gray-700">Date: </span>
          {{ row.date || "Not Available" }}
        </p>
        <p>
          <span class="font-medium text-gray-700">Assigned Date:</span>
          {{ row.assignedDate || "Not Available" }}
        </p>
        <p>
          <span class="font-medium text-gray-700">Due Date:</span>
          {{ row.dueDate || "Not Available" }}
        </p>
        <p class="flex flex-wrap gap-1 mt-3">
          <span
            class="text-xs rounded-full font-medium mb-1 px-2 py-0.5 inline-flex items-center whitespace-nowrap"
            [ngClass]="{
              'bg-yellow-100 text-yellow-700': row.approvalStatus === 'In Progress' || row.approvalStatus === 'Pending',
              'bg-indigo-100 text-indigo-700': row.approvalStatus === 'Viewed',
              'bg-green-100 text-green-700': row.approvalStatus === 'Approved',
              'bg-red-100 text-red-700': row.approvalStatus === 'Rejected'
            }"
          >
            Approval: {{ row.approvalStatus || "Not Available" }}
          </span>
        </p>
      </div>

      <!-- Document context fields (letters) -->
      <div *ngIf="context !== 'users' && context !== 'routing-slips'">
        <p>
          <span class="font-medium text-gray-700">Assigned Date:</span>
          {{ row.uploadDate || "Not Available" }}
        </p>
        <p *ngIf="showActions">
          <span class="font-medium text-gray-700">Source:</span>
          {{ row.source || "Not Available" }}
        </p>

        <p>
          <span class="font-medium text-gray-700">Due Date:</span>
          {{ row.dueDate || "Not Available" }}
        </p>
        <!-- <p>
          <span class="font-medium text-gray-700">Assigned To:</span>
          {{ row.assignedTo || "Not Available" }}
        </p> -->
        <!-- <p>
          <span class="font-medium text-gray-700">Priority:</span>
          <span
            class="px-2 py-0.5 rounded-full text-xs"
            [ngClass]="{
              'bg-red-100 text-red-700': row.priority === 'High',
              'bg-yellow-100 text-yellow-700': row.priority === 'Medium',
              'bg-blue-100 text-blue-700': row.priority === 'Low'
            }"
          >
            {{ row.priority || "Not Available" }}
          </span>
        </p> -->
        <p class="flex flex-wrap mt-2">
          <span
            class="text-xs rounded-full font-medium mb-2 px-2 py-1"
            [ngClass]="{
              'bg-green-100 text-green-700': row.status === 'Responded',
              'bg-yellow-100 text-yellow-700': row.status === 'Pending',
              'bg-red-100 text-red-700': row.status === 'Rejected',
              'bg-blue-100 text-blue-700': row.status === 'Approved',
              'bg-gray-100 text-gray-700':
                row.status === 'Archived' ||
                ![
                  'Responded',
                  'Pending',
                  'Rejected',
                  'Approved',
                  'Archived'
                ].includes(row.status)
            }"
          >
            <span>{{ row.status || "Not Available" }}</span>
          </span>
        </p>
      </div>
    </div>

    <!-- Actions -->
    <div *ngIf="showActions" class="flex justify-end gap-2 mt-3">
      <!-- Users context: Show Edit and Archive buttons on mobile/tablet -->
      <div *ngIf="context === 'users' && !isArchivedView" class="flex gap-2">
        <button
          (click)="onEdit(row); $event.stopPropagation()"
          class="px-3 py-1 text-xs bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition flex items-center gap-1"
        >
          <i class="pi pi-pencil text-xs"></i>
          Edit
        </button>
        <button
          (click)="onDelete(row); $event.stopPropagation()"
          class="px-3 py-1 text-xs bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition flex items-center gap-1"
        >
          <i class="pi pi-trash text-xs"></i>
          Archive
        </button>
      </div>

      <!-- Show message for archived users -->
      <div
        *ngIf="context === 'users' && isArchivedView"
        class="flex items-center text-xs text-gray-500 italic"
      >
        Archived users cannot be edited or archived
      </div>

      <!-- Show message for archived letters -->
      <div
        *ngIf="context === 'letters' && isArchivedView"
        class="flex items-center text-xs text-gray-500 italic"
      >
        Archived letters cannot be edited or processed
      </div>

      <!-- Show message for archived routing slips -->
      <div
        *ngIf="context === 'routing-slips' && isArchivedView"
        class="flex items-center text-xs text-gray-500 italic"
      >
        Archived routing slips cannot be edited or processed
      </div>

      <!-- Other contexts: Show View button -->
      <!-- <button
        *ngIf="context !== 'users'"
        (click)="onRowClick(row)"
        class="px-3 py-1 text-xs bg-indigo-100 text-indigo-700 rounded-lg hover:bg-indigo-200 transition"
      >
        View
      </button> -->
    </div>
  </div>
</div>

<ng-template #empty>
  <p class="text-gray-500 text-center py-4">No Data Available</p>
</ng-template>
